module.exports = __webpack_public_path__ + "static/assets/e075d6595edb3a3d2122d6cc447a23b4.svg";